import { userApi } from './index';
import { config } from '../config';
import { InternetAccount, IUserAvailableServices } from '../../../models/Accounts';
import { OnlineSession, ListOfSessions } from '../../../models/Sessions';

interface EditInternetDevicePasswordOrLoginProps {
  login?: string;
  password?: string;
  accountId: number | string;
  currentPassword: string;
}

interface EditInternetDeviceMacProps {
  mac: string;
  accountId: number | string;
  currentPassword: string;
}

export interface GetListOfSessionsProps {
  accountId: string | number;
  perPage?: number;
  page?: number;
  dateFrom?: string;
  dateTo?: string;
}

export const internetApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    getInternetInfo: build.query<InternetAccount, { accountId: string | number }>({
      query: ({ accountId }) => ({
        url: config.INTERNET.ACCOUNT_INFO(accountId),
      }),
      providesTags: () => ['Accounts'],
    }),
    getAvailableInternetServices: build.query<IUserAvailableServices, { accountId: string | number }>({
      query: ({ accountId }) => ({
        url: config.INTERNET.SERVICES_AVAILABLE(accountId),
      }),
      providesTags: () => ['Accounts'],
    }),
    getListOfSessions: build.query<ListOfSessions, GetListOfSessionsProps>({
      query: ({ accountId, perPage, page, dateFrom, dateTo }) => ({
        url: config.INTERNET.LIST_OF_SESSIONS(accountId),
        params: {
          perPage,
          page,
          dateFrom,
          dateTo,
        },
      }),
    }),
    getCurrentSession: build.query<OnlineSession, { accountId: string | number }>({
      query: ({ accountId }) => ({
        url: config.INTERNET.CURRENT_SESSION(accountId),
      }),
    }),
    updateLoginOrPassword: build.mutation<{ success: boolean }, EditInternetDevicePasswordOrLoginProps>({
      query: ({ login, password, accountId, currentPassword }) => ({
        url: config.INTERNET.UPDATE_PASSWORD_OR_LOGIN(accountId),
        method: 'PATCH',
        body: {
          login,
          password,
          currentPassword,
        },
      }),
      invalidatesTags: ['Accounts'],
    }),
    changeMac: build.mutation<{ success: boolean }, EditInternetDeviceMacProps>({
      query: ({ mac, accountId, currentPassword }) => {
        return {
          url: config.INTERNET.CHANGE_MAC(accountId),
          method: 'PATCH',
          body: {
            currentPassword,
            mac,
          },
        };
      },
      invalidatesTags: ['Accounts'],
    }),
  }),
});
